export default __webpack_public_path__ + "e6eaeeca91463e7166b5ce7b160b198c.svg";